import React from 'react';
import './GOQiiLoader.css';

import topLeft        from '../assets/logo_parts/goqii_top_left.png';
import topRight       from '../assets/logo_parts/goqii_top_right.png';
import bottomLeft     from '../assets/logo_parts/goqii_bottom_left.png';
import brLeft         from '../assets/logo_parts/goqii_bottom_right_left.png';
import brRight        from '../assets/logo_parts/goqii_bottom_right_right.png';

// Replicates the RN size math exactly
const compute = (size) => {
  const splitGap       = Math.max(3, Math.round(size * 0.025));
  const tileSize       = (size - splitGap) / 2;
  const tile4InnerGap  = Math.max(1, Math.round(tileSize * 0.02));
  const tile4Inner     = (tileSize - tile4InnerGap) / 2;
  return { splitGap, tileSize, tile4InnerGap, tile4Inner };
};

const GOQiiLoader = ({ visible = false, size = 70 }) => {
  if (!visible) return null;

  const { splitGap, tileSize, tile4InnerGap, tile4Inner } = compute(size);

  return (
    <div className="goqii-loader-overlay">
      <div className="goqii-loader-wrap" style={{ width: size, height: size }}>

        {/* ── Top row: tile 0 (orange) + tile 1 (red) ── */}
        <div className="goqii-loader-row">
          <img src={topLeft}  alt="" className="goqii-tile goqii-tile-0"
               style={{ width: tileSize, height: tileSize }} />
          <div style={{ width: splitGap }} />
          <img src={topRight} alt="" className="goqii-tile goqii-tile-1"
               style={{ width: tileSize, height: tileSize }} />
        </div>

        <div style={{ height: splitGap }} />

        {/* ── Bottom row: tile 2 (green) + tile 3/4 (blue split) ── */}
        <div className="goqii-loader-row">
          <img src={bottomLeft} alt="" className="goqii-tile goqii-tile-2"
               style={{ width: tileSize, height: tileSize }} />
          <div style={{ width: splitGap }} />

          {/* Bottom-right: two halves animated independently */}
          <div className="goqii-loader-row"
               style={{ width: tileSize, height: tileSize }}>
            <img src={brLeft}  alt="" className="goqii-tile goqii-tile-3"
                 style={{ width: tile4Inner, height: tileSize }} />
            <div style={{ width: tile4InnerGap }} />
            <img src={brRight} alt="" className="goqii-tile goqii-tile-4"
                 style={{ width: tile4Inner, height: tileSize }} />
          </div>
        </div>

      </div>
    </div>
  );
};

export default GOQiiLoader;
